import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import SpinnerWithLoadMask from "components/SpinnerWithLoadMask";
import FolderSummaryContent from "layout/folderSummary/FolderSummaryContent";
import ErrorFallbackModal from "components/Modal/ErrorFallbackModal";

const FolderSummary = () => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallbackModal}>
      <SpinnerWithLoadMask opacity={0.7} fullScreen />
      <FolderSummaryContent />
    </ErrorBoundary>
  );
};

export default FolderSummary;
